import { Box, Text } from '@wix/design-system';
import { FeatureGroup as FeatureGroupComp } from '@wix/package-picker-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdvancedPlansProductData, FeaturesGroupSection } from '../../../types';
import { FeatureRow } from './FeatureRow';

interface FeatureGroupProps {
  group: FeaturesGroupSection;
  products: AdvancedPlansProductData[];
  isJapanesePackagePicker?: boolean;
}

const FeatureGroup: React.FC<FeatureGroupProps> = ({
  group,
  products,
  isJapanesePackagePicker = false,
}) => {
  const { t } = useTranslation();

  return (
    <FeatureGroupComp
      header={
        <Box>
          <Text weight='bold'>{t(group.translationKey)}</Text>
        </Box>
      }
    >
      {group.features.map((feature, idx) => (
        <FeatureRow
          key={idx}
          products={products}
          feature={feature}
          isJapanesePackagePicker={isJapanesePackagePicker}
        />
      ))}
    </FeatureGroupComp>
  );
};

export default FeatureGroup;
